import { apiWrapper } from 'ccs-ui-components';
import { IExceptionDuplicateSearch } from '../../../models';
import { searchExceptionArraySchema } from '../../../utilities/sources/RegistriesSchemaDefintion';

/**
 * Custom hook to call source registry name validation api
 * @returns promise
 */
const useDuplicateExceptionCheck = () => {
  async function callDuplicateExceptionCheck(exceptionList: string[]) {
    const requestData = {
      exceptionNames: exceptionList,
      exactNameMatch: true
    };
    const resp = await apiWrapper.post<IExceptionDuplicateSearch, { errorMessage: string }
    >(
      `${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/exceptions/search`,
      requestData
    );
    /**
    * @method apiResult
    * @description Validating the api response using joi.
    */
    const apiResponse = searchExceptionArraySchema.validate(resp.responseBody?.ersExceptions, {
      abortEarly: true
    });

    if (resp.isError || !apiResponse.value) {
      return {
        errorMessage: resp.errorBody?.errorMessage,
        isError: resp.isError,
        statusCode: resp.statusCode
      };
    }
    const validExceptionList = resp.responseBody?.ersExceptions?.map((exception) => exception.ersExceptionName);
    return {
      validExceptionList,
      isError: resp.isError,
      statusCode: resp.statusCode
    };
  }

  const checkDuplicateException = (exceptionList: string[]) => callDuplicateExceptionCheck(exceptionList);

  return { checkDuplicateException };
};

export default useDuplicateExceptionCheck;
